import _ from 'lodash';

import { CoreEnums } from '@/utils/domain/constants';
import BaseFieldHandler from '../BaseFieldHandler';
import { JSON_DATA_TYPES } from '../constants';
import { getCurrentUser, instanceDataFieldValue, mapMultiChoice } from '../utils';

const { FormFieldType, FormFieldStringType } = CoreEnums;

export default class ChoiceFieldHandler extends BaseFieldHandler {
  static supportedTypes = [FormFieldStringType.Choice, FormFieldType.Choice];

  handle() {
    const config = this.getBaseConfig();
    const { isDetails, isLocked } = this.fieldState;
    const { isCustomList, isDynamicEntity, isContinue } = this.routeInfo;
    const deeps = this.getDependencies();

    const {
      allowMultiple,
      allowInsertNewOption,
      autoSelect,
      autoSelectAll,
      maxSelectionsAllowed,
      minSelectionsRequired,
      currentUser,
      userDisplayValue,
      userExtraField,
      formId,
      type,
    } = this.baseConfig;

    let { choices } = this.baseConfig;

    if (_.isString(choices)) {
      choices = choices.split(';');
    }

    const fieldConfig = {
      ...config,
      type: isDetails && !allowMultiple ? 'text' : 'select',
      remote: false,
      labelInValue: false,
      options: choices?.map((k) => ({ label: k, value: k })),

      ...(!isDetails && {
        ...(isCustomList && { isCustomList: true }),
        ...(allowInsertNewOption && { allowInsertOptionManually: allowInsertNewOption }),
        ...(isLocked && { showSearch: false, allowClear: false }),
        ...(this.dependency && autoSelect && { isAutoSelectItemEnabled: autoSelect }),
        ...(isDynamicEntity && { isDynamicEntity: true, entityId: isDynamicEntity.params.id }),
        ...(deeps?.length > 0 && { deeps, relationships: true }),
        ...this.getCommonFormRouteProps(),
      }),

      ...(allowMultiple && {
        mode: 'multiple',
        // Show every selected chip (wrap) — maxTagCount hid choices behind "+ …".
        ...(maxSelectionsAllowed > 1 && { maxSelectionsAllowed }),
        ...(minSelectionsRequired > 1 && { minSelectionsRequired }),
        isAutoSelectAllEnabled: autoSelectAll,
        value: mapMultiChoice(config.value),
      }),

      ...(!allowMultiple &&
        (_.isObject(config.value) || this.isJsonLike(config.value)) && {
          value: instanceDataFieldValue(
            JSON_DATA_TYPES.includes(type),
            config.value,
            this.dependency,
            isDetails,
          ),
        }),
    };

    if (isContinue && !isLocked && currentUser) {
      fieldConfig.value = getCurrentUser(type, { userDisplayValue, userExtraField });
    }

    return fieldConfig;
  }
}
